import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerformanceStoreModule } from 'src/app/store/performance/performance-store.module';
import { HoldingsStoreModule } from 'src/app/store/holdings/holdings-store.module';
import { CashflowStoreModule } from 'src/app/store/cashflow/cashflow-store.module';
import { ReportRequestStoreModule } from '../report-requests/report-request-store.module';
import { ClientFacade } from 'src/app/store/client/facade/client.facade';
import { ClientEffects } from 'src/app/store/client/effects/client.effects';
import * as fromClient from './reducers/client.reducers';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('client', fromClient.ClientReducer),
        EffectsModule.forFeature([ClientEffects]),
        HoldingsStoreModule,
        CashflowStoreModule,
        PerformanceStoreModule,
        ReportRequestStoreModule
    ],
    providers: [
        ClientEffects,
        ClientFacade
    ]
})
export class ClientStoreModule {}
